import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=3f8eac6c&scoped=true"
import script from "./CustomSearch.vue?vue&type=script&lang=js"
export * from "./CustomSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=3f8eac6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8eac6c",
  null
  
)

export default component.exports